<template>
  <div class="markdown-body" v-html="parsedMessage" />
</template>
<script setup lang="ts">
import { computed } from "vue";

import DOMPurify from "dompurify";
import "github-markdown-css/github-markdown.css";
import { marked } from "marked";

const { content } = defineProps<{ content: string }>();

const parsedMessage = computed(() => {
  const rawHtml = marked.parse(content) as string;
  return DOMPurify.sanitize(rawHtml).trimEnd();
});
</script>
<style scoped>
@reference "@/assets/tailwind.css";

.markdown-body {
  @apply bg-transparent text-[14px] text-inherit;
  /* `overflow-wrap: anywhere` (not `break-word`) shrinks min-content so flex/grid
     children can actually wrap long URLs instead of escaping the container. */
  overflow-wrap: anywhere;

  & :deep(p) {
    @apply mb-0;
  }

  & :deep(ul) {
    @apply list-disc;
  }

  & :deep(ol) {
    @apply list-decimal;
  }

  /* github-markdown-css sets `white-space: pre` on <pre>/<pre> code,
     which ignores `overflow-wrap` and lets long lines escape the bubble. */
  & :deep(pre),
  & :deep(pre code) {
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  &.truncate.whitespace-nowrap {
    & :deep(p) {
      @apply truncate whitespace-nowrap;
    }
  }
}
</style>
